import {
  DxScrolling,
  DxPager,
  DxPaging,
  DxSelection,
  DxDataGrid
} from "devextreme-vue/data-grid"
import ModuleInvoice from "@/views/components/module-invoice"
import ModuleEInvoiceDetail from "@/views/components/module-einvoice-detail"
import EInvoiceDetail from "./e-invoice-detail"
import SeparateRowPreviewModal from "./separate-row-preview-modal.vue"
import { adjustOrReplaceEInvoice, createDraftEInvoice, createEInvoice, 
        getDetailEInvoice, publishEInvoice, changeEInvoice, 
        signEInvoice, editDraftEInvoice, deleteEInvoice,
        previewTempPdfEInvoice, createInternalEinvoice, editInternalDraftInvoices, getInternalStatus } from "@/api/action-defines/e-invoice-management"

import {detailSiteApi} from "@/api/action-defines/site-management"
import dayjs from "dayjs"
import { showToast } from "@/@core/utils/utils"
import { v4 as uuidv4 } from 'uuid'
import { mapState , mapGetters} from "vuex"
import { INVOICE_ACTION } from "@/@core/data/enum/eInvoiceActionType"
import { INVOICE_STATUS_CODE} from '@/@core/data/enum/invoiceStatus';
import { PartnerCode } from "@/@core/data/enum/partnerCode"
import { getSitePartner } from "@/api/action-defines/site-management"
import { EInvoiceActionCodes } from '@/@core/data/enum/menuCode';

export default {
  components: {
    DxSelection,
    DxDataGrid,
    DxScrolling,
    DxPager,
    DxPaging,
    ModuleEInvoiceDetail,
    ModuleInvoice,
    EInvoiceDetail,
    SeparateRowPreviewModal,
  },

  props: {
    actionType: {
      type: String,
      required: false,
      default: INVOICE_ACTION.ADD_INVOICE
    },
    invoiceId: {
      type: String,
      required: false,
      default: null,
    },
    invoiceNum: {
      type: String,
      required: false,
      default: null,
    },
    displayType: {
      type: String,
      required: false,
      default: '',
    },
    statusEinvoice: {
      type: Number,
      required: false,
      default: 0,
    },
    statusSign:{
      type: Boolean,
      required: false,
      default: true,
    },
    internal:{
      type: Boolean,
      required: false,
      default: null,
    }
  },

  data() {
    return {
      isOpen: false,
      invoiceAction: INVOICE_ACTION,
      invoiceStatusCode: INVOICE_STATUS_CODE,
      partnerInfo: {},
      tempInvoiceData: null,
      tempInvoiceItems: [],
      pendingApiCall: null,
      autoOpenWhenModuleToInvoice: true,
      isInternalInvoice: false,
    }
  },
  async created() {
    this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', []);
    this.$store.commit('eInvoiceManagement/UPDATE_ADDED_GROUPS', []);
    this.$store.commit('eInvoiceManagement/UPDATE_ADDED_INVOICES', []);
    this.$store.commit('eInvoiceManagement/SELECT_ALL', false);
    await this.getPartnerInfo();
    // Load internal status once when component is created
    if (this.invoiceId) {
      this.isInternalInvoice = await this.isInternal();
    }
    console.log('this.actionType', this.actionType);
  },
  methods: {
    // Helper method to get items detail with grouping information
    getItemsDetailWithGroupInfo() {
      const itemsDetailResult = this.$refs.moduleEInvoiceDetail.getItemsDetail();
      return {
        items: itemsDetailResult.items,
        isGrouped: itemsDetailResult.isGrouped
      };
    },

    // Method to prepare request body with item details and grouping info
    prepareRequestBodyWithGroupInfo(invoiceDetail, itemsDetailInfo) {
      return {
        ...invoiceDetail,
        EInvoiceDetails: itemsDetailInfo.items,
        IsGrouped: itemsDetailInfo.isGrouped // Include grouping flag
      };
    },

    // Method to prepare invoice data with items detail info
    prepareInvoiceData(detailData) {
      // Get items detail with grouping information
      const itemsDetailInfo = this.getItemsDetailWithGroupInfo();
      const itemsDetail = itemsDetailInfo.items;
      const isGrouped = itemsDetailInfo.isGrouped;

      const eInvoiceDate = !!detailData.EinvoiceDate ?
        dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString() :
        dayjs().toISOString();

      // Process items
      const targetItems = itemsDetail.items ?? itemsDetail;

      if (targetItems) {
        targetItems.forEach(item => {
          item.SubAmount = item.BeforeTaxAmount;
          item.ReferenceItemId = item.ItemId;
          item.TaxRate = item.Tax;
          item.ServiceRate = item.Charges;
          item.ServicesCharge = item.ChargesAmount;
          item.DiscountPercent = 0;
          item.AfterTaxAmount = item.TotalAmount;
        });
      }

      const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();
      
      const isBHInvoice = this.$ls_EInvoiceConfig?.InvoiceType === 'BH_INVOICE';

      // Create invoice detail object
      const invoiceDetail = {
        ...detailData,
        ezCloudClientID: uuidv4(),
        EinvoiceDate: eInvoiceDate,
        FormNo: detailData.FormInvoice,
        Serial: detailData.Serial,
        CurrencyCode: 'VND',
        ExchangeRate: 0,
        SubAmount: einvoiceData.SubAmount,
        DiscountPercent: 0,
        DiscountAmount: einvoiceData.DiscountAmount,
        ServiceRate: einvoiceData.ServiceRate,
        ServicesCharge: einvoiceData.ServicesCharge,
        BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
        TaxRate: 0,
        TaxAmount: einvoiceData.TaxAmount,
        AfterTaxAmount: einvoiceData.AfterTaxAmount,
        StatusSign: false,
        HotelId: '0',
        IsTaxReduction43: isBHInvoice
      };
      
      // Prepare and return the final body data
      return {
        invoiceDetail,
        itemsDetailInfo,
        bodyData: this.prepareRequestBodyWithGroupInfo(invoiceDetail, itemsDetailInfo)
      };
    },

    closeAddEInvoice() {
      this.isOpen = false;
      document.querySelector('body').style.overflow = 'unset';
      document.querySelector('html').style.overflow = 'unset';
    },

    openModuleInvoice() {
      this.$refs.moduleInvoice.isOpen = true;
    },

    async getPartnerInfo() {
      const res = await getSitePartner();
      this.partnerInfo = res.Data;
    },

    async handleSaveDraft() {
      // Refresh internal status before processing
      await this.refreshInternalStatus();
      
      const { VNPT } = PartnerCode;

      const partnerNotHaveCreateDraftEInvoice = [VNPT];

      if (partnerNotHaveCreateDraftEInvoice.includes(this.partnerInfo.PartnerCode)) {
        return;
      }

      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };

      // Get items detail with grouping information
      const itemsDetailInfo = this.getItemsDetailWithGroupInfo();
      const itemsDetail = itemsDetailInfo.items;
      const isGrouped = itemsDetailInfo.isGrouped;

      const eInvoiceDate = !!detailData.EinvoiceDate ?
        dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString() :
        dayjs().toISOString();

      itemsDetail.map(item => {
        item.SubAmount = item.BeforeTaxAmount,
          item.ReferenceItemId = item.ItemId,
          item.TaxRate = item.Tax
        item.ServiceRate = item.Charges;
        item.ServicesCharge = item.ChargesAmount;
        item.DiscountPercent = 0;
        item.AfterTaxAmount = item.TotalAmount;
      })

      this.$refs.EInvoiceDetail.isOpen = true;
      const res = await this.$refs.EInvoiceDetail.validateFormReturnInfor();

      if (res.length > 0) {
        let text = this.$t('add_einvoice_pls_insert_required_input') + ': ';
        res.forEach(element => {
          text += this.$t(element) + ', ';
        });
        text = text.slice(0, -2) + '.';
        this.$toast.error(text);
        return;
      }

      const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();

      const invoiceDetail = {
        ...detailData,
        ezCloudClientID: uuidv4(),
        EinvoiceDate: eInvoiceDate,
        FormNo: detailData.FormInvoice,
        Serial: detailData.Serial,
        CurrencyCode: 'VND',
        ExchangeRate: 0,
        SubAmount: 0,
        DiscountPercent: 0,
        DiscountAmount: einvoiceData.DiscountAmount,
        ServiceRate: 0,
        ServicesCharge: einvoiceData.ServicesCharge,
        BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
        TaxRate: 0,
        TaxAmount: einvoiceData.TaxAmount,
        AfterTaxAmount: einvoiceData.AfterTaxAmount,
        StatusSign: false,
        HotelId: '0'
      };

      // Add grouping information to the body data
      const bodyData = {
        ...invoiceDetail,
        EInvoiceDetails: itemsDetail,
        IsGrouped: isGrouped // Include grouping flag
      };
      
      
      var isItemNameNull = false;
      let onlyExternalService = true;
      bodyData.EInvoiceDetails.forEach(elm =>{
        if (elm.ItemName === "" || elm.ItemName === null || elm.ItemName === undefined){
          isItemNameNull = true;
        }
        if (elm.GroupItemId !== null){
          onlyExternalService = false;
        }
      });

      if (onlyExternalService){
        let text = this.$t('add_einvoice_unable_create_invoice_without_services_external_providers_pls_check_and_try_again')
        this.$toast.error(text);
        return;
      }
      
      if(isItemNameNull){
        let text = this.$t('item_name_cant_null');
        this.$toast.error(text);
        return;
      }


      this.$refs.EInvoiceDetail.isOpen = true;
      
      await createDraftEInvoice({ BodyData: bodyData }).then(res => {
        if (res.StatusCode === '200') {
          this.$toast.success(this.$t('success'));
          this.$router.push({
            name: 'invoice-management',
            query: { reload: true }
          });
          this.closeAddEInvoice();
          this.$emit('update-list-einvoice');
        }
      })
      
    },

    async createInternalEinvoice() {
      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };

      // Get items detail with grouping information
      const itemsDetailInfo = this.getItemsDetailWithGroupInfo();
      const itemsDetail = itemsDetailInfo.items;
      const isGrouped = itemsDetailInfo.isGrouped;

      const eInvoiceDate = !!detailData.EinvoiceDate ?
        dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString() :
        dayjs().toISOString();

      itemsDetail.map(item => {
        item.SubAmount = item.BeforeTaxAmount,
          item.ReferenceItemId = item.ItemId,
          item.TaxRate = item.Tax
        item.ServiceRate = item.Charges;
        item.ServicesCharge = item.ChargesAmount;
        item.DiscountPercent = 0;
        item.AfterTaxAmount = item.TotalAmount;
      })

      this.$refs.EInvoiceDetail.isOpen = true;
      const res = await this.$refs.EInvoiceDetail.validateFormReturnInfor();

      if (res.length > 0) {
        let text = this.$t('add_einvoice_pls_insert_required_input') + ': ';
        res.forEach(element => {
          text += this.$t(element) + ', ';
        });
        text = text.slice(0, -2) + '.';
        this.$toast.error(text);
        return;
      }

      const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();

      const invoiceDetail = {
        ...detailData,
        ezCloudClientID: uuidv4(),
        EinvoiceDate: eInvoiceDate,
        FormNo: detailData.FormInvoice,
        Serial: detailData.Serial,
        CurrencyCode: 'VND',
        ExchangeRate: 0,
        SubAmount: 0,
        DiscountPercent: 0,
        DiscountAmount: einvoiceData.DiscountAmount,
        ServiceRate: 0,
        ServicesCharge: einvoiceData.ServicesCharge,
        BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
        TaxRate: 0,
        TaxAmount: einvoiceData.TaxAmount,
        AfterTaxAmount: einvoiceData.AfterTaxAmount,
        StatusSign: false,
        HotelId: '0'
      };

      // Add grouping information to the body data
      const bodyData = {
        ...invoiceDetail,
        EInvoiceDetails: itemsDetail,
        IsGrouped: isGrouped // Include grouping flag
      };
      
      
      var isItemNameNull = false;
      let onlyExternalService = true;
      bodyData.EInvoiceDetails.forEach(elm =>{
        if (elm.ItemName === "" || elm.ItemName === null || elm.ItemName === undefined){
          isItemNameNull = true;
        }
        if (elm.GroupItemId !== null){
          onlyExternalService = false;
        }
      });

      if (onlyExternalService){
        let text = this.$t('add_einvoice_unable_create_invoice_without_services_external_providers_pls_check_and_try_again')
        this.$toast.error(text);
        return;
      }
      
      if(isItemNameNull){
        let text = this.$t('item_name_cant_null');
        this.$toast.error(text);
        return;
      }


      this.$refs.EInvoiceDetail.isOpen = true;
      
      await createInternalEinvoice({ BodyData: bodyData }).then(res => {
        if (res.StatusCode === '200') {
          this.$toast.success(this.$t('success'));
          this.$router.push({
            name: 'invoice-management',
            query: { reload: true }
          });
          this.closeAddEInvoice();
          this.$emit('update-list-einvoice');
        }
      })
      
    },

    async handleSave(){
      // Refresh internal status before processing
      await this.refreshInternalStatus();
      
      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };

      if (detailData.StatusEinvoice && detailData.StatusEinvoice === INVOICE_STATUS_CODE.DRAFT){
        // Get items detail with grouping information
        const itemsDetailInfo = this.getItemsDetailWithGroupInfo();
        const itemsDetail = itemsDetailInfo.items;
        const isGrouped = itemsDetailInfo.isGrouped;

        const eInvoiceDate = !!detailData.EinvoiceDate ?
          dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString() :
          dayjs().toISOString();

        itemsDetail.map(item => {
          item.SubAmount = item.BeforeTaxAmount,
            item.ReferenceItemId = item.ItemId,
            item.TaxRate = item.Tax
          item.ServiceRate = item.Charges;
          item.ServicesCharge = item.ChargesAmount;
          item.DiscountPercent = 0;
          item.AfterTaxAmount = item.TotalAmount;
        })

        this.$refs.EInvoiceDetail.isOpen = true;
        const res = await this.$refs.EInvoiceDetail.validateFormReturnInfor();

        if (res.length > 0) {
          let text = this.$t('add_einvoice_pls_insert_required_input') + ': ';
          res.forEach(element => {
            text += this.$t(element) + ', ';
          });
          text = text.slice(0, -2) + '.';
          this.$toast.error(text);
          return;
        }

        const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();

        const invoiceDetail = {
          ...detailData,
          ezCloudClientID: uuidv4(),
          EinvoiceDate: eInvoiceDate,
          FormNo: detailData.FormInvoice,
          Serial: detailData.Serial,
          CurrencyCode: 'VND',
          ExchangeRate: 0,
          SubAmount: 0,
          DiscountPercent: 0,
          DiscountAmount: einvoiceData.DiscountAmount,
          ServiceRate: 0,
          ServicesCharge: einvoiceData.ServicesCharge,
          BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
          TaxRate: 0,
          TaxAmount: einvoiceData.TaxAmount,
          AfterTaxAmount: einvoiceData.AfterTaxAmount,
          StatusSign: false,
          HotelId: '0'
        };

        // Add grouping information to the body data
        const bodyData = {
          ...invoiceDetail,
          EInvoiceDetails: itemsDetail,
          IsGrouped: isGrouped // Include grouping flag
        };

      var isItemNameNull = false;
      let onlyExternalService = true;
      bodyData.EInvoiceDetails.forEach(elm =>{
        if (elm.ItemName === "" || elm.ItemName === null || elm.ItemName === undefined){
          isItemNameNull = true;
        }
        if (elm.GroupItemId !== null){
          onlyExternalService = false;
        }
      });

      if (onlyExternalService){
        let text = this.$t('add_einvoice_unable_create_invoice_without_services_external_providers_pls_check_and_try_again')
        this.$toast.error(text);
        return;
      }
      
      if(isItemNameNull){
        let text = this.$t('item_name_cant_null');
        this.$toast.error(text);
        return;
      }
      
        this.$refs.EInvoiceDetail.isOpen = true;
        
        try {
          const response = await editDraftEInvoice({ BodyData: bodyData });
          if (response?.StatusCode == 200) {
            this.$toast.success(this.$t('success'));
  
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
            this.closeAddEInvoice();
            this.$emit('update-list-einvoice');
          } else {
          }
        } catch (error) {
        }
      }else{
        // Get items detail with grouping information
        const itemsDetailInfo = this.getItemsDetailWithGroupInfo();
        const itemsDetail = itemsDetailInfo.items;
        const isGrouped = itemsDetailInfo.isGrouped;
  
        const eInvoiceDate = !!detailData.EinvoiceDate
          ? dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString()
          : dayjs().toISOString();
  
        const targetItems = itemsDetail.items ?? itemsDetail;
  
        if (targetItems) {
          targetItems.forEach(item => {
            item.SubAmount = item.BeforeTaxAmount;
            item.ReferenceItemId = item.ItemId;
            item.TaxRate = item.Tax;
            item.ServiceRate = item.Charges;
            item.ServicesCharge = item.ChargesAmount;
            item.DiscountPercent = 0;
            item.AfterTaxAmount = item.TotalAmount;
          });
        }

        this.$refs.EInvoiceDetail.isOpen = true;
        const res = await this.$refs.EInvoiceDetail.validateFormReturnInfor();

        if (res.length > 0) {
          let text = this.$t('add_einvoice_pls_insert_required_input') + ': ';
          res.forEach(element => {
            text += this.$t(element) + ', ';
          });
          text = text.slice(0, -2) + '.';
          this.$toast.error(text);
          return;
        }
  
        const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();
  
        const invoiceDetail = {
          ...detailData,
          ezInvoiceIdOld: this.invoiceId,
          OldThirdPartyInvoiceNumber: null,
          UpdateType: 'Change',
          ezCloudClientID: uuidv4(),
          EinvoiceDate: eInvoiceDate,
          EinvoiceNo: null,
          FormNo: detailData.FormInvoice,
          Serial: detailData.Serial,
          CurrencyCode: 'VND',
          ExchangeRate: 0,
          SubAmount: 0,
          DiscountPercent: 0,
          DiscountAmount: einvoiceData.DiscountAmount,
          ServiceRate: 0,
          ServicesCharge: einvoiceData.ServicesCharge,
          BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
          TaxRate: 0,
          TaxAmount: einvoiceData.TaxAmount,
          AfterTaxAmount: einvoiceData.AfterTaxAmount,
          StatusSign: false,
          HotelId: '0',
        };
  
        // Add grouping information to the body data
        const bodyData = {
          ...invoiceDetail,
          EInvoiceDetails: itemsDetail,
          IsGrouped: isGrouped // Include grouping flag
        };
  
      var isItemNameNull = false;
      bodyData.EInvoiceDetails.forEach(elm =>{
        if (elm.ItemName === "" || elm.ItemName === null || elm.ItemName === undefined){
          isItemNameNull = true;
        }
      });

      if(isItemNameNull){
        let text = this.$t('item_name_cant_null');
        this.$toast.error(text);
        return;
      }

        
        try {
          const response = await changeEInvoice({ BodyData: bodyData });
          if (response?.StatusCode == 200) {
            this.$toast.success(this.$t('success'));
  
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
            this.closeAddEInvoice();
            this.$emit('update-list-einvoice');
          } else {
          }
        } catch (error) {
        }
      }

    },

    async editInternalDraftInvoices(){
      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };

      if (detailData.StatusEinvoice && detailData.StatusEinvoice === INVOICE_STATUS_CODE.DRAFT){
        // Get items detail with grouping information
        const itemsDetailInfo = this.getItemsDetailWithGroupInfo();
        const itemsDetail = itemsDetailInfo.items;
        const isGrouped = itemsDetailInfo.isGrouped;

        const eInvoiceDate = !!detailData.EinvoiceDate ?
          dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString() :
          dayjs().toISOString();

        itemsDetail.map(item => {
          item.SubAmount = item.BeforeTaxAmount,
            item.ReferenceItemId = item.ItemId,
            item.TaxRate = item.Tax
          item.ServiceRate = item.Charges;
          item.ServicesCharge = item.ChargesAmount;
          item.DiscountPercent = 0;
          item.AfterTaxAmount = item.TotalAmount;
        })

        this.$refs.EInvoiceDetail.isOpen = true;
        const res = await this.$refs.EInvoiceDetail.validateFormReturnInfor();

        if (res.length > 0) {
          let text = this.$t('add_einvoice_pls_insert_required_input') + ': ';
          res.forEach(element => {
            text += this.$t(element) + ', ';
          });
          text = text.slice(0, -2) + '.';
          this.$toast.error(text);
          return;
        }

        const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();

        const invoiceDetail = {
          ...detailData,
          ezCloudClientID: uuidv4(),
          EinvoiceDate: eInvoiceDate,
          FormNo: detailData.FormInvoice,
          Serial: detailData.Serial,
          CurrencyCode: 'VND',
          ExchangeRate: 0,
          SubAmount: 0,
          DiscountPercent: 0,
          DiscountAmount: einvoiceData.DiscountAmount,
          ServiceRate: 0,
          ServicesCharge: einvoiceData.ServicesCharge,
          BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
          TaxRate: 0,
          TaxAmount: einvoiceData.TaxAmount,
          AfterTaxAmount: einvoiceData.AfterTaxAmount,
          StatusSign: false,
          HotelId: '0'
        };

        // Add grouping information to the body data
        const bodyData = {
          ...invoiceDetail,
          EInvoiceDetails: itemsDetail,
          IsGrouped: isGrouped // Include grouping flag
        };

        var isItemNameNull = false;
        let onlyExternalService = true;
        bodyData.EInvoiceDetails.forEach(elm =>{
          if (elm.ItemName === "" || elm.ItemName === null || elm.ItemName === undefined){
            isItemNameNull = true;
          }
          if (elm.GroupItemId !== null){
              onlyExternalService = false;
          }
        });

        if (onlyExternalService){
          let text = this.$t('add_einvoice_unable_create_invoice_without_services_external_providers_pls_check_and_try_again')
          this.$toast.error(text);
          return;
        }
        
        if(isItemNameNull){
          let text = this.$t('item_name_cant_null');
          this.$toast.error(text);
          return;
        }
      
        this.$refs.EInvoiceDetail.isOpen = true;
        
        try {
          const response = await editInternalDraftInvoices({ BodyData: bodyData });
          if (response?.StatusCode == 200) {
            this.$toast.success(this.$t('success'));
  
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
            this.closeAddEInvoice();
            this.$emit('update-list-einvoice');
          } else {
          }
        } catch (error) {
        }
      }
    },

    async isInternal(){
      const BodyData = {
        einvoiceId: this.invoiceId // Lấy từ props
      };
      
      try {
        const res = await getInternalStatus({ BodyData: BodyData });
        if (res.StatusCode === '200') {
          return res.Data; // Hoặc res.Data.IsInternal tùy theo cấu trúc response
        }
        return false;
      } catch (error) {
        console.error('Error getting internal status:', error);
        return false;
      }
    },

    // Helper method to refresh internal status before API calls
    async refreshInternalStatus() {
      if (this.invoiceId) {
        this.isInternalInvoice = await this.isInternal();
      }
    },

    async confirmAddEinvoiceFunc(){
      this.$refs.confirmAddEinvoice.isOpen = false;
      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };
      
      // Prepare invoice data with items detail and grouping info
      const { bodyData, itemsDetailInfo } = this.prepareInvoiceData(detailData);
      const { items: itemsDetail } = itemsDetailInfo;
      
      // Extract partner codes from PartnerCode enum
      const { VNPT, VNPT_V5, SUN, VIETTEL, MISA, EASY, CMC, MINVOICE, CYBER_BILL } = PartnerCode;
      const partnerHavePublishEInvoice = [VNPT, VNPT_V5, SUN, VIETTEL, MISA, EASY];
      const parnerHaveCreateEInvoice = [CMC, MINVOICE, CYBER_BILL];
      
      // Check if using SEPARATE_ROW charge option
      if (this.hasSeparateRowChargeOption()) {
        // Show preview modal with the data
        if (parnerHaveCreateEInvoice.includes(this.partnerInfo.PartnerCode)) {
          this.showSeparateRowPreview(bodyData, itemsDetail, async () => {
            
            const res = await createEInvoice({ BodyData: bodyData });
            if (res.StatusCode === '200') {
              this.$toast.success(this.$t('success'));
              this.$router.push({
                name: 'invoice-management',
                query: { reload: true }
              });
              this.closeAddEInvoice();
              this.$emit('update-list-einvoice');
            }
            return res;
          });
        } else if (partnerHavePublishEInvoice.includes(this.partnerInfo.PartnerCode)) {
          this.showSeparateRowPreview(bodyData, itemsDetail, async () => {
            
            const res = await publishEInvoice({ BodyData: bodyData });
            if (res.StatusCode === '200') {
              this.$toast.success(this.$t('success'));
              this.$router.push({
                name: 'invoice-management',
                query: { reload: true }
              });
              this.closeAddEInvoice();
              this.$emit('update-list-einvoice');
            }
            
            return res;
          });
        }
      } else {
        // Use original flow without preview
        if (parnerHaveCreateEInvoice.includes(this.partnerInfo.PartnerCode)) {
          
          await createEInvoice({ BodyData: bodyData }).then(res => {
            if (res.StatusCode === '200') {
              this.$toast.success(this.$t('success'));
              this.$router.push({
                name: 'invoice-management',
                query: { reload: true }
              });
              this.closeAddEInvoice();
              this.$emit('update-list-einvoice');
            }
          });
        } else if (partnerHavePublishEInvoice.includes(this.partnerInfo.PartnerCode)) {
          
          await publishEInvoice({ BodyData: bodyData }).then(res => {
            if (res.StatusCode === '200') {
              this.$toast.success(this.$t('success'));
              this.$router.push({
                name: 'invoice-management',
                query: { reload: true }
              });
              this.closeAddEInvoice();
              this.$emit('update-list-einvoice');
            }
          });
        }
      }
      
    },

    async confirmPreviewTempEinvoiceFunc(){
      this.$refs.confirmPreviewTempEinvoice.isOpen = false;

      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };
      
      // Prepare invoice data with items detail and grouping info
      const { bodyData, itemsDetailInfo } = this.prepareInvoiceData(detailData);
      const { items: itemsDetail } = itemsDetailInfo;
      
      // Extract partner codes from PartnerCode enum
      const { VIETTEL, MISA, FAST, EASY} = PartnerCode;
      const partnerHavePreviewTempPdfEInvoice = [VIETTEL, MISA, FAST, EASY];
      
      // Use original flow without preview
      if (partnerHavePreviewTempPdfEInvoice.includes(this.partnerInfo.PartnerCode)) {
        
        await previewTempPdfEInvoice({ BodyData: bodyData }).then(res => {
          if (res.StatusCode === '200') {
            this.$toast.success(this.$t('success'));
            if (res.Data.Type === 1){
              const base64PDF = res.Data.InvoicePDF;
              const byteCharacters = atob(base64PDF);
              const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
              const byteArray = new Uint8Array(byteNumbers);

              const blob = new Blob([byteArray], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);
              window.open(blobUrl);
            }

            if (res.Data.Type === 2){
              const pdfUrl = res.Data.InvoicePDF; // link trả về từ API
              window.open(pdfUrl, '_blank');
            }
          }
        });
      }
    },

    async confirmReplaceEinvoiceFunc(){
      this.$refs.confirmReplaceEinvoice.isOpen = false;
      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };

      // Get items detail with grouping information
      const itemsDetailInfo = this.getItemsDetailWithGroupInfo();
      const itemsDetail = itemsDetailInfo.items;
      const isGrouped = itemsDetailInfo.isGrouped;

      const eInvoiceDate = !!detailData.EinvoiceDate
        ? dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString()
        : dayjs().toISOString();

      const targetItems = itemsDetail.items ?? itemsDetail;

      if (targetItems) {
        targetItems.forEach(item => {
          item.SubAmount = item.BeforeTaxAmount;
          item.ReferenceItemId = item.ReferenceItemId ? item.ReferenceItemId : item.ItemId;
          item.TaxRate = item.Tax;
          item.ServiceRate = item.Charges;
          item.ServicesCharge = item.ChargesAmount;
          item.DiscountPercent = 0;
          item.AfterTaxAmount = item.TotalAmount;
        });
      }

      const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();

      const invoiceDetail = {
        ...detailData,
        ezInvoiceIdOld: this.invoiceId,
        OldThirdPartyInvoiceNumber: null,
        UpdateType: this.replaceType,
        ezCloudClientID: uuidv4(),
        EinvoiceDate: eInvoiceDate,
        EinvoiceNo: null,
        FormNo: detailData.FormInvoice,
        Serial: detailData.Serial,
        CurrencyCode: 'VND',
        ExchangeRate: 0,
        SubAmount: 0,
        DiscountPercent: 0,
        DiscountAmount: einvoiceData.DiscountAmount,
        ServiceRate: 0,
        ServicesCharge: einvoiceData.ServicesCharge,
        BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
        TaxRate: 0,
        TaxAmount: einvoiceData.TaxAmount,
        AfterTaxAmount: einvoiceData.AfterTaxAmount,
        StatusSign: false,
        HotelId: '0',
      };

      // Add grouping information to the body data
      const bodyData = {
        ...invoiceDetail,
        EInvoiceDetails: itemsDetail,
        IsGrouped: isGrouped // Include grouping flag
      };
      try {
        // Check if using SEPARATE_ROW charge option
        if (this.hasSeparateRowChargeOption()) {
          // Show preview modal with the data
          this.showSeparateRowPreview(bodyData, itemsDetail, async () => {
            
            const response = await adjustOrReplaceEInvoice({ BodyData: bodyData });
            if (response?.StatusCode == 200) {
              this.$toast.success(this.$t('success'));
              this.$router.push({
                name: 'invoice-management',
                query: { reload: true }
              });
              this.$emit('update-list-einvoice');
              this.closeAddEInvoice();
            } else {
              this.$toast.error(this.$t('common_fail'));
            }
            
            return response;
          });
        } else {
          // Use original flow without preview
          
          const response = await adjustOrReplaceEInvoice({ BodyData: bodyData });
          if (response?.StatusCode == 200) {
            this.$toast.success(this.$t('success'));
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
            this.$emit('update-list-einvoice');
            this.closeAddEInvoice();
          } else {
            this.$toast.error(this.$t('common_fail'));
          }
        }
      } catch (error) {
        this.$toast.error(this.$t('common_fail'));
      }
      
    },
    async confirmAdjustEinvoiceFunc(){
      this.$refs.confirmAdjustEinvoice.isOpen = false;
      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };

      // Get items detail with grouping information
      const itemsDetailInfo = this.getItemsDetailWithGroupInfo();
      const itemsDetail = itemsDetailInfo.items;
      const isGrouped = itemsDetailInfo.isGrouped;

      const eInvoiceDate = !!detailData.EinvoiceDate
        ? dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString()
        : dayjs().toISOString();

      const targetItems = itemsDetail.items ?? itemsDetail;

      if (targetItems) {
        targetItems.forEach(item => {
          item.SubAmount = item.BeforeTaxAmount;
          item.ReferenceItemId = item.ReferenceItemId ? item.ReferenceItemId : item.ItemId;
          item.TaxRate = item.Tax;
          item.ServiceRate = item.Charges;
          item.ServicesCharge = item.ChargesAmount;
          item.DiscountPercent = 0;
          item.AfterTaxAmount = item.TotalAmount;
        });
      }

      const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();

      const invoiceDetail = {
        ...detailData,
        ezInvoiceIdOld: this.invoiceId,
        OldThirdPartyInvoiceNumber: null,
        UpdateType: this.adjustType,
        ezCloudClientID: uuidv4(),
        EinvoiceDate: eInvoiceDate,
        EinvoiceNo: null,
        FormNo: detailData.FormInvoice,
        Serial: detailData.Serial,
        CurrencyCode: 'VND',
        ExchangeRate: 0,
        SubAmount: 0,
        DiscountPercent: 0,
        DiscountAmount: einvoiceData.DiscountAmount,
        ServiceRate: 0,
        ServicesCharge: einvoiceData.ServicesCharge,
        BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
        TaxRate: 0,
        TaxAmount: einvoiceData.TaxAmount,
        AfterTaxAmount: einvoiceData.AfterTaxAmount,
        StatusSign: false,
        HotelId: '0',
      };

      // Add grouping information to the body data
      const bodyData = {
        ...invoiceDetail,
        EInvoiceDetails: itemsDetail,
        IsGrouped: isGrouped // Include grouping flag
      };
      try {
        // Check if using SEPARATE_ROW charge option
        if (this.hasSeparateRowChargeOption()) {
          // Show preview modal with the data
          this.showSeparateRowPreview(bodyData, itemsDetail, async () => {
            
            const response = await adjustOrReplaceEInvoice({ BodyData: bodyData });
            if (response?.StatusCode == 200) {
              this.$toast.success(this.$t('success'));
              this.$router.push({
                name: 'invoice-management',
                query: { reload: true }
              });
              this.closeAddEInvoice();
              this.$emit('update-list-einvoice');
            } else {
              this.$toast.error(this.$t('common_fail'));
            }
                  
            return response;
          });
        } else {
          // Use original flow without preview
          
          const response = await adjustOrReplaceEInvoice({ BodyData: bodyData });
          if (response?.StatusCode == 200) {
            this.$toast.success(this.$t('success'));
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
            this.closeAddEInvoice();
            this.$emit('update-list-einvoice');
            } else {
            this.$toast.error(this.$t('common_fail'));
          }
        }
      } catch (error) {
        this.$toast.error(this.$t('common_fail'));
      }
      
    },
    async handleReleaseInvoice() {
      // Refresh internal status before processing
      await this.refreshInternalStatus();
      
      this.$refs.confirmAddEinvoice.isOpen = false;
      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        Cccd: null,
        Passport: null,
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };
      
      // Get items detail with grouping information
      const itemsDetailInfo = this.getItemsDetailWithGroupInfo();
      const itemsDetail = itemsDetailInfo.items;
      const isGrouped = itemsDetailInfo.isGrouped;

      const eInvoiceDate = !!detailData.EinvoiceDate ?
        dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString() :
        dayjs().toISOString();
        
      itemsDetail.map(item => {
        item.SubAmount = item.BeforeTaxAmount,
        item.ReferenceItemId = item.ItemId,
        item.TaxRate = item.Tax
        item.ServiceRate = item.Charges;
        item.ServicesCharge = item.ChargesAmount;
        item.DiscountPercent = 0;
        item.AfterTaxAmount = item.TotalAmount;
      })

      const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();
      const invoiceDetail = {
        ...detailData,
        ezCloudClientID: uuidv4(),
        EinvoiceDate: eInvoiceDate,
        FormNo: detailData.FormInvoice,
        Serial: detailData.Serial,
        CurrencyCode: 'VND',
        ExchangeRate: 0,
        SubAmount: 0,
        DiscountPercent: 0,
        DiscountAmount: einvoiceData.DiscountAmount,
        ServiceRate: 0,
        ServicesCharge: einvoiceData.ServicesCharge,
        BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
        TaxRate: 0,
        TaxAmount: einvoiceData.TaxAmount,
        AfterTaxAmount: einvoiceData.AfterTaxAmount,
        StatusSign: false,
        HotelId: '0'
      };
      
      // Add grouping information to the body data
      const bodyData = {
        ...invoiceDetail,
        EInvoiceDetails: itemsDetail,
        IsGrouped: isGrouped // Include grouping flag
      };
      
      this.$refs.EInvoiceDetail.isOpen = true;
      const res = await this.$refs.EInvoiceDetail.validateFormReturnInfor();

      if (res.length > 0) {
        let text = this.$t('add_einvoice_pls_insert_required_input') + ': ';
        res.forEach(element => {
          text += this.$t(element) + ', ';
        });
        text = text.slice(0, -2) + '.';
        this.$toast.error(text);
        return;
      }
      
      const QueryParameters = {
        siteId: this.$ls_CurrentSiteID,
      };

      let connectezInvoice = true;
      await detailSiteApi({ QueryParameters }).then((res) => {
        if (res.IsSuccess) {
          if(res.Data.Status.toUpperCase() !== 'ACTIVE'){
            let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
            this.$toast.error(text);
            connectezInvoice = false;
          }
        }
      });

      if (!connectezInvoice) return;

      if (bodyData.EInvoiceDetails.length <= 0){
        let text = this.$t('add_einvoice_pls_add_service')
        this.$toast.error(text);
        return;
      }

      let onlyExternalService = true;
      let itemNameIsNull = false;
      bodyData.EInvoiceDetails.forEach(elm =>{
        if (elm.ItemName === "" || elm.ItemName === null || elm.ItemName === undefined){
          itemNameIsNull = true;
        }
        if (elm.GroupItemId !== null){
          onlyExternalService = false;
        }
      });

      if (onlyExternalService){
        let text = this.$t('add_einvoice_unable_create_invoice_without_services_external_providers_pls_check_and_try_again')
        this.$toast.error(text);
        return;
      }

      if (itemNameIsNull){
        let text = this.$t('item_name_cant_null');
        this.$toast.error(text);
        return;
      }

      
      this.$refs.confirmAddEinvoice.isOpen = true;
    },
    async handleReplacingInvoice() {
      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };

      const itemsDetail = this.$refs.moduleEInvoiceDetail.getItemsDetail();

      const eInvoiceDate = !!detailData.EinvoiceDate
        ? dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString()
        : dayjs().toISOString();

      const targetItems = itemsDetail.items ?? itemsDetail;

      if (targetItems) {
        targetItems.forEach(item => {
          item.SubAmount = item.BeforeTaxAmount;
          item.ReferenceItemId = item.ItemId;
          item.TaxRate = item.Tax;
          item.ServiceRate = item.Charges;
          item.ServicesCharge = item.ChargesAmount;
          item.DiscountPercent = 0;
          item.AfterTaxAmount = item.TotalAmount;
        });
      }

      const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();

      const invoiceDetail = {
        ...detailData,
        ezInvoiceIdOld: this.invoiceId,
        OldThirdPartyInvoiceNumber: null,
        UpdateType: this.replaceType,
        ezCloudClientID: uuidv4(),
        EinvoiceDate: eInvoiceDate,
        EinvoiceNo: null,
        FormNo: detailData.FormInvoice,
        Serial: detailData.Serial,
        CurrencyCode: 'VND',
        ExchangeRate: 0,
        SubAmount: 0,
        DiscountPercent: 0,
        DiscountAmount: einvoiceData.DiscountAmount,
        ServiceRate: 0,
        ServicesCharge: einvoiceData.ServicesCharge,
        BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
        TaxRate: 0,
        TaxAmount: einvoiceData.TaxAmount,
        AfterTaxAmount: einvoiceData.AfterTaxAmount,
        StatusSign: false,
        HotelId: '0',
      };

      const BodyData = {
        ...invoiceDetail,
        EInvoiceDetails: itemsDetail,
      };

      // Mở form để xác thực
      this.$refs.EInvoiceDetail.isOpen = true;
      const res = await this.$refs.EInvoiceDetail.validateFormReturnInfor();

      if (res.length > 0) {
        let text = this.$t('add_einvoice_pls_insert_required_input') + ': ';
        res.forEach(element => {
          text += this.$t(element) + ', ';
        });
        text = text.slice(0, -2) + '.';
        this.$toast.error(text);
        return;
      }
      
      const QueryParameters = {
        siteId: this.$ls_CurrentSiteID,
      };
      let connectezInvoice = true;
      await detailSiteApi({ QueryParameters }).then((res) => {
        if (res.IsSuccess) {
          if(res.Data.Status.toUpperCase() !== 'ACTIVE'){
            let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
            this.$toast.error(text);
            connectezInvoice = false;
          }
        }
      });

      if (!connectezInvoice) return;

      if (BodyData.EInvoiceDetails.items.length <= 0){
        let text = this.$t('add_einvoice_pls_add_service')
        this.$toast.error(text);
        return;
      }

      let onlyExternalService = true;
      var isItemNameNull = false;
      BodyData.EInvoiceDetails.items.forEach(elm =>{
        if (elm.ItemName === "" || elm.ItemName === null || elm.ItemName === undefined){
          isItemNameNull = true;
        }
        if (elm.GroupItemId !== null){
          onlyExternalService = false;
        }
      });

      if (onlyExternalService){
        let text = this.$t('add_einvoice_unable_create_invoice_without_services_external_providers_pls_check_and_try_again')
        this.$toast.error(text);
        return;
      }

      if(isItemNameNull){
        let text = this.$t('item_name_cant_null');
        this.$toast.error(text);
        return;
      }


      this.$refs.confirmReplaceEinvoice.isOpen = true;
    },
    async handleAdjustInvoice(type) {
      // Lấy thông tin hóa đơn từ component EInvoiceDetail
      let detailData = {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CompanyAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        TaxReduction43Amount: null,
        ...this.$refs.EInvoiceDetail.getDetailData()
      };

      const itemsDetail = this.$refs.moduleEInvoiceDetail.getItemsDetail();

      const eInvoiceDate = !!detailData.EinvoiceDate
        ? dayjs(detailData.EinvoiceDate, 'DD/MM/YYYY').toISOString()
        : dayjs().toISOString();

      const targetItems = itemsDetail.items ?? itemsDetail;

      if (targetItems) {
        targetItems.forEach(item => {
          item.SubAmount = item.BeforeTaxAmount;
          item.ReferenceItemId = item.ItemId;
          item.TaxRate = item.Tax;
          item.ServiceRate = item.Charges;
          item.ServicesCharge = item.ChargesAmount;
          item.DiscountPercent = 0;
          item.AfterTaxAmount = item.TotalAmount;
        });
      }

      const einvoiceData = this.$refs.moduleEInvoiceDetail.getTotalData();

      const invoiceDetail = {
        ...detailData,
        ezInvoiceIdOld: this.invoiceId,
        OldThirdPartyInvoiceNumber: null,
        UpdateType: this.adjustType,
        ezCloudClientID: uuidv4(),
        EinvoiceDate: eInvoiceDate,
        EinvoiceNo: null,
        FormNo: detailData.FormInvoice,
        Serial: detailData.Serial,
        CurrencyCode: 'VND',
        ExchangeRate: 0,
        SubAmount: 0,
        DiscountPercent: 0,
        DiscountAmount: einvoiceData.DiscountAmount,
        ServiceRate: 0,
        ServicesCharge: einvoiceData.ServicesCharge,
        BeforeTaxAmount: einvoiceData.BeforeTaxAmount,
        TaxRate: 0,
        TaxAmount: einvoiceData.TaxAmount,
        AfterTaxAmount: einvoiceData.AfterTaxAmount,
        StatusSign: false,
        HotelId: '0',
      };

      const BodyData = {
        ...invoiceDetail,
        EInvoiceDetails: itemsDetail,
      };

      this.$refs.EInvoiceDetail.isOpen = true;
      const res = await this.$refs.EInvoiceDetail.validateFormReturnInfor();
      if (res.length > 0) {
        let text = this.$t('add_einvoice_pls_insert_required_input') + ': ';
        res.forEach(element => {
          text += this.$t(element) + ', ';
        });
        text = text.slice(0, -2) + '.';
        this.$toast.error(text);
        return;
      }
      
      const QueryParameters = {
        siteId: this.$ls_CurrentSiteID,
      };
      let connectezInvoice = true;
      await detailSiteApi({ QueryParameters }).then((res) => {
        if (res.IsSuccess) {
          if(res.Data.Status.toUpperCase() !== 'ACTIVE'){
            let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
            this.$toast.error(text);
            connectezInvoice = false;
          }
        }
      });

      if (!connectezInvoice) return;
      
      if (BodyData.EInvoiceDetails.items.length <= 0){
        let text = this.$t('add_einvoice_pls_add_service')
        this.$toast.error(text);
        return;
      }

      let onlyExternalService = true;
      let isItemNameNull = false;
      BodyData.EInvoiceDetails.items.forEach(elm =>{
        if (elm.ItemName === "" || elm.ItemName === null || elm.ItemName === undefined){
          isItemNameNull= true;
        }

        if (elm.GroupItemId !== null){
          onlyExternalService = false;
        }
      });

      if (onlyExternalService){
        let text = this.$t('add_einvoice_unable_create_invoice_without_services_external_providers_pls_check_and_try_again')
        this.$toast.error(text);
        return;
      }

      if(isItemNameNull){
        let text = this.$t('item_name_cant_null');
        this.$toast.error(text);
        return;
      }

      this.$refs.confirmAdjustEinvoice.isOpen = true;
    },
    async handleSignInvoice (){
      this.$refs.signEinvoice.isOpen = true;
    },
    async confirmSignEinvoiceFunc() {
      const BodyData = { Id: this.invoiceId };
      
      try {
        const response = await signEInvoice({ BodyData });
        if (response != undefined && response.StatusCode == 200) {
          this.$toast.success(this.$t('common_success_sign_einvoice'));
          this.$emit('update-list-einvoice');
        } else {
          this.$toast.error(this.$t('common_fail_sign_einvoice'));
        }
      } catch (error) {
        this.$toast.error(this.$t('common_fail_sign_einvoice'));
      }
      this.$refs.signEinvoice.isOpen = false;
    },
    async getPaymentMethods() {
      const BodyData = {
        Partner: {
          All: false,
          In: [],
        }
      }
      getPaymentMethods({ BodyData })
        .then(res => {
          if (res.StatusCode === '200') {
            this.paymentMethodList = res.Data.map(method => {
              return {
                text: method.PaymentDescription,
                value: method.PaymentCode,
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    clearStore() {
      this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', []);
      this.$store.commit('eInvoiceManagement/UPDATE_ADDED_GROUPS', []);
      this.$store.commit('eInvoiceManagement/UPDATE_ADDED_INVOICES', []);
      this.$store.commit('eInvoiceManagement/UPDATE_FILLED_ITEMS', []);
      this.$store.commit('eInvoiceManagement/SELECT_ALL', false);
    },

    // Method to show preview modal for SEPARATE_ROW
    showSeparateRowPreview(invoiceData, invoiceItems, apiCallFunc) {
      this.tempInvoiceData = invoiceData;
      this.tempInvoiceItems = invoiceItems;
      this.pendingApiCall = apiCallFunc;

      this.$nextTick(() => {
        this.$refs.separateRowPreviewModal.showModal(invoiceData, invoiceItems);
      });
    },

    // Method to handle confirmation from the SEPARATE_ROW preview modal
    async handleSeparateRowPreviewConfirm() {
      if (!this.pendingApiCall || !this.tempInvoiceData) return;
      
      try {
        // Call the API function that was pending
        const result = await this.pendingApiCall();
        
        // Reset the temporary data
        this.tempInvoiceData = null;
        this.tempInvoiceItems = [];
        this.pendingApiCall = null;
        
        return result;
      } catch (error) {
        console.error('Error in handleSeparateRowPreviewConfirm:', error);
        this.$toast.error('Đã xảy ra lỗi khi xử lý hóa đơn');
        
        // Reset the temporary data
        this.tempInvoiceData = null;
        this.tempInvoiceItems = [];
        this.pendingApiCall = null;
        
        throw error;
      }
    },

    // Method to handle cancellation from the SEPARATE_ROW preview modal
    handleSeparateRowPreviewCancel() {
      // Reset the temporary data
      this.tempInvoiceData = null;
      this.tempInvoiceItems = [];
      this.pendingApiCall = null;
    },

    // Helper method to check if the invoice has SEPARATE_ROW charge option
    hasSeparateRowChargeOption() {
      return this.$ls_EInvoiceConfig?.ChargeOption === 'SEPARATE_ROW';
    },
    moduleToEInvoiceGetSearchParamFill(){
      let isRedirected = sessionStorage.getItem('isRedirected');
      if (isRedirected === "true"){
        this.$refs.btnAddInvoice.click();
      }
    },
    isCanPreviewTempEInvoice() {
      const { VIETTEL, SUN, CYBER_BILL, VNPT, VNPT_V5, EASY, MISA, FAST} = PartnerCode;
      console.log('partner code:', this.partnerInfo.PartnerCode);
      return [VIETTEL, MISA, FAST].includes(this.partnerInfo.PartnerCode);
    },
    moduleToEInvoiceFillGuestInfo(){
      let isRedirected = sessionStorage.getItem('isRedirected');
      if (isRedirected === "true"){
        this.$refs.EInvoiceDetail.isOpen = true;
      }
    },
     isCanAddEInvoice() {
      return this.$lsAllowOperation(EInvoiceActionCodes.RELEASE);
    },
    isCanDraftEInvoice() {
      const { VIETTEL, SUN, CYBER_BILL, VNPT, VNPT_V5, EASY} = PartnerCode;
      return this.$lsAllowOperation(EInvoiceActionCodes.DRAFT)
      && [VIETTEL, SUN, CYBER_BILL, VNPT, VNPT_V5, EASY].includes(this.partnerInfo.PartnerCode)
      && (this.invoiceAction.ADD_INVOICE === this.actionType  || this.isInternalInvoice);
    },
    isCanPreviewTempPDF() {

      const { VNPT, VNPT_V5, SUN, VIETTEL, MISA, EASY, CMC} = PartnerCode;
      return this.$lsAllowOperation(EInvoiceActionCodes.PREVIEW_TEMP_PDF)
      && [VNPT, VNPT_V5, SUN, VIETTEL, MISA, EASY, CMC].includes(this.partnerInfo.PartnerCode)
      && this.invoiceAction.PREVIEW_TEMP_EINVOICE === this.actionType;
    },
    isCanEditEInvoice() {
      const { MINVOICE, CYBER_BILL, VNPT, VNPT_V5} = PartnerCode;
      const { DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT} = INVOICE_STATUS_CODE;

      if (this.$lsAllowOperation(EInvoiceActionCodes.EDIT)){
        if ([MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode)){
          if ([ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.statusEinvoice) && !this.statusSign){
            return true;
          }
        }

        if ([VNPT, VNPT_V5].includes(this.partnerInfo.PartnerCode)){
          if ([DRAFT].includes(this.statusEinvoice) && !this.statusSign){
            return true;
          }
        }
      }
      return false;
    },
    isCanDeleteEInvoice(){
      const { MINVOICE, CYBER_BILL, VNPT, VNPT_V5, EASY} = PartnerCode;
      const { DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT} = INVOICE_STATUS_CODE;

      if (this.$lsAllowOperation(EInvoiceActionCodes.DELETE)){
        if ([MINVOICE].includes(this.partnerInfo.PartnerCode)) {
          if ([ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.statusEinvoice) && !this.statusSign ){
            return true;
          }
        }

        if ([CYBER_BILL].includes(this.partnerInfo.PartnerCode)) {
          if ([ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.statusEinvoice) && !thisstatusSign ){
            return true;
          }

          if ([DRAFT].includes(this.statusEinvoice)){
            return true;
          }
        }

        if ([VNPT, VNPT_V5, EASY].includes(this.partnerInfo.PartnerCode)) {
          if ([DRAFT].includes(this.statusEinvoice)){
            return true;
          }
        }
      }

      return false;
      

    },
    openDeletePopup() {
      this.$refs.confirmDelete.isOpen = true;
    },
    async confirmDelete(reason) {
          const BodyData = {
            Id: this.invoiceId,
            Reason: "",
          };
          await deleteEInvoice({ BodyData: BodyData })
            .then((res) => {
              if (res.StatusCode === '200') {
                this.$refs.confirmDelete.isOpen = false;
                this.isOpen = false;
                showToast('success', this.$t('common_success'));
              }
            })
        },
    isShowAdjustBtn() {
      return this.actionType === INVOICE_ACTION.ADJUST_INCREASE_INVOICE ||
        this.actionType === INVOICE_ACTION.ADJUST_DECREASE_INVOICE ||
        this.actionType === INVOICE_ACTION.ADJUST_INVOICE ||
        this.actionType === INVOICE_ACTION.ADJUST_INVOICE_INFORMATION ||
        this.actionType === INVOICE_ACTION.ADJUST_INVOICE_VALUE;
    },
    isShowSignBtn() {
      const { MINVOICE, CYBER_BILL} = PartnerCode;
      const {DRAFT} = INVOICE_STATUS_CODE;
      return this.$lsAllowOperation(EInvoiceActionCodes.SIGN) 
      && [MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode) 
      && ![DRAFT].includes(this.statusEinvoice)
      && this.actionType === INVOICE_ACTION.CHANGE_INVOICE;
    },
    isShowReplaceBtn() {
      return this.actionType === INVOICE_ACTION.REPLACE_INVOICE;
    },
  },
  computed: {
    ...mapState({
      $ls_Items: (state) => state.eInvoiceManagement.items,
      $ls_EInvoiceConfig: (state) => state.eInvoiceManagement.eInvoiceConfig,
      $ls_Sites: (state) => state.app.resources.Sites,
    }),
    ...mapGetters({
      $ls_CurrentSiteID: 'auth/currentSiteID',
      $lsAllowOperation: 'app/allowOperation',
    }),
    // ...mapGetters({
    //   $ls_CurrentSiteID: 'auth/currentSiteID',
    //   $lsAllowOperation: 'app/allowOperation',
    // }),
    // isCanDraftEInvoice() {
    //   return this.$lsAllowOperation(EInvoiceActionCodes.DRAFT);
    // },

    isActionTypeChanged() {
      if (this.actionType === 'replace_invoice') {
        return true
      }
      return false
    },
    isShowModuleInvoiceExpand() {
      //TODO - add user permission
      return true;
    },
    
    replaceType() {
      return 'ReplaceInvoice';
    },
    adjustType() {
      switch (this.actionType) {
        case INVOICE_ACTION.ADJUST_INVOICE:
          return 'AdjustInvoice';

        case INVOICE_ACTION.ADJUST_INVOICE_INFORMATION:
          return 'AdjustInfor';

        case INVOICE_ACTION.ADJUST_INVOICE_VALUE:
          return 'AdjustInvoice';

        case INVOICE_ACTION.ADJUST_INCREASE_INVOICE:
          return 'AdjustIncrease';

        case INVOICE_ACTION.ADJUST_DECREASE_INVOICE:
          return 'AdjustDecrease';

        default:
          return null;
      }
    },
  },
  watch: {
    async isOpen(newVal, oldVal) {
      if (!newVal) {
        document.querySelector('html').style.overflow = 'scroll';
        this.clearStore();
        return;
      };
      document.querySelector('html').style.overflow = 'hidden';
      
      // Refresh internal status when opening invoice
      await this.refreshInternalStatus();
      
      if (this.actionType !== INVOICE_ACTION.ADD_INVOICE) {
        const BodyData = {
          EInvoiceId: this.invoiceId,
        };
        await getDetailEInvoice({ BodyData: BodyData })
          .then((res) => {
            if (res.StatusCode === "200") {
              const items = res.Data.EInvoiceDetails.map(item => {
                this.$set(item, 'isAdded', true);
                return {
                  ...item,
                  ItemId: item.Id,
                  TotalAmount: item.AfterTaxAmount,
                  Tax: item.TaxRate,
                  ChargesAmount: item.ServicesCharge,
                  Charges: item.ServiceRate,
                  DisplayUnitPrice: item.Price,
                  PreChargesAmount: item.ChargesAmount,
                  PreTaxAmount: item.TaxAmount,
                  PreTotalAmount: item.TotalAmount,
                  isAdded: true,
                };
              })
              // this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', items);
              this.$refs.moduleEInvoiceDetail.fillItemsDetail(items);
              // Fill formData
              this.$refs.EInvoiceDetail.formData = { ...res.Data.EInvoice, FormInvoice: res.Data.EInvoice.FormNo };
              let year = res.Data.EInvoice.EinvoiceDate.slice(0,4);
              let month = res.Data.EInvoice.EinvoiceDate.slice(5,7);
              let day = res.Data.EInvoice.EinvoiceDate.slice(8,10);
              let hour = res.Data.EInvoice.EinvoiceDate.slice(11,13);
              let minute = res.Data.EInvoice.EinvoiceDate.slice(14,16);
              let second = res.Data.EInvoice.EinvoiceDate.slice(17,19);
              const date = dayjs().set('year', year)
                    .set('month', month - 1)
                    .set('date', day)
                    .set('hour', hour)
                    .set('minute', minute)
                    .set('second', second)
                    .add(7, 'hours');
              this.$refs.EInvoiceDetail.formData.EinvoiceDate = date.toDate();
              this.$refs.EInvoiceDetail.listReference = res.Data.ListReference;
              this.$refs.EInvoiceDetail.invoiceStatuts = res.Data.EInvoice.StatusEinvoice;
              this.$refs.EInvoiceDetail.signStatus = res.Data.EInvoice.StatusSign;
              this.$refs.EInvoiceDetail.taxAuthorityStatus = res.Data.EInvoice.TaxAuthorityStatus;
            } else {
              console.log(res.Messages);
            }
          })
          .catch((error) => {
            console.log(error);
          });

      }

    }
  },
  beforeDestroy() {
    this.clearStore();
  }
}